import { Route, Routes } from 'react-router-dom';
import { ReportHistory, ReportSchedules } from '@/app/administration/routes/lazyPages';
import {
  ChangeWizard,
  PortfolioAnalyticsPage,
  PortfolioClientDetailPage,
  PortfolioClientsPage,
  PortfolioHealthPage,
  PortfolioReportsPage,
  PortfolioWorkplaceIntelligencePage,
} from '@/capabilities/customer-lifecycle/public/routes/lazyPages';
import { TimeSavingsReport } from '@/capabilities/service-operations/public/routes/lazyPages';
import { ClientOffboarding } from '@/workflows/customer-offboarding/public/routes/lazyPages';
import { ClientOnboardingHub } from '@/workflows/tenant-setup/public/routes/lazyPages';
import { destinationCapabilityRouteElements } from '@/app/navigation/routes/capabilities/destinationCapabilityRegistry';

export function PortfolioRoutes() {
  return (
    <Routes>
      <Route index element={<PortfolioClientsPage />} />
      <Route path="analytics" element={<PortfolioAnalyticsPage />} />
      <Route path="workplace-intelligence" element={<PortfolioWorkplaceIntelligencePage />} />
      <Route path="reports" element={<PortfolioReportsPage />} />
      <Route path="reports/history" element={<ReportHistory />} />
      <Route path="reports/schedules" element={<ReportSchedules />} />
      <Route path="reports/time-savings" element={<TimeSavingsReport />} />
      <Route path="health" element={<PortfolioHealthPage />} />
      <Route path=":id" element={<PortfolioClientDetailPage />} />
      <Route path=":id/lifecycle" element={<PortfolioClientDetailPage />} />
      <Route path=":id/people" element={<PortfolioClientDetailPage />} />
      <Route path=":id/health" element={<PortfolioClientDetailPage />} />
      <Route path=":id/procurement" element={<PortfolioClientDetailPage />} />
      <Route path=":id/commercial" element={<PortfolioClientDetailPage />} />
      <Route path=":id/qbr" element={<PortfolioClientDetailPage />} />
      <Route path=":id/reports" element={<PortfolioClientDetailPage />} />
      <Route path=":id/activity" element={<PortfolioClientDetailPage />} />
      <Route path=":id/runways" element={<PortfolioClientDetailPage />} />
      <Route path=":id/blueprint" element={<PortfolioClientDetailPage />} />
      <Route path=":id/lifecycle/change" element={<ChangeWizard />} />
      <Route path=":customerId/lifecycle/onboarding" element={<ClientOnboardingHub />} />
      <Route path=":customerId/lifecycle/offboarding" element={<ClientOffboarding />} />
      {destinationCapabilityRouteElements('portfolio')}
    </Routes>
  );
}
